export const DEFAULT_DATA_GRID_LOCALE_TEXT = {
  noRowsLabel: 'Nenhum registro encontrado',
  noResultsOverlayLabel: 'Nenhum resultado encontrado',
  paginationRowsPerPage: 'Itens por página',
  paginationDisplayedRows: ({
    from,
    to,
    count,
  }: {
    from: number
    to: number
    count: number
  }) => `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`,
}
